export enum PublishedEnum {
  IMMEDIATELY = 'IMMEDIATELY',
  CUSTOM = 'CUSTOM',
}
